import { Button, Tooltip } from 'antd';
import { url } from '../../../constants/api';
import { ModalTrigger } from '@arivaa-react/components/modal';
import { ApiForm } from '../../../containers/apiForm';

export const MigrateThemeConfig = () => {
  return (
    <ModalTrigger
      modalProps={{
        title: 'Migrate Website Configurations',
        footer: null,
      }}
      content={
        <ApiForm
          successMessage={'Websites migrated successfully'}
          apiUrl={url(`website-configurations/migrate-website`)}
          method="POST"
          elements={[
            {
              type: 'text',
              label: 'Migration Name',
              name: 'migrationName',
              required: true,
            },
          ]}
          rules={[
            {
              required: true,
              message: 'Migration Name is required',
            },
          ]}
        />
      }
    >
      <Tooltip title="Migrate website configurations" placement="bottom">
        <Button className="btn blue-btn-text">Migrate configurations</Button>
      </Tooltip>
    </ModalTrigger>
  );
};
